<template>
  <transition name="up-slide">
    <div v-if="updateStore.state.updateAvailable" class="update-prompt" role="status">
      <span class="up-text">
        {{ updateStore.state.applying
          ? 'Updating Rosterem…'
          : 'A new version of Rosterem is available' }}
      </span>
      <!-- Disabled while applying so the click produces visible feedback and a
           second click cannot arm a second skipWaiting/timeout pair. The store
           guards this too; the attribute is what makes it visible. -->
      <button
        class="up-reload-btn"
        :disabled="updateStore.state.applying"
        @click="updateStore.applyUpdate()"
      >{{ updateStore.state.applying ? 'Updating…' : 'Reload' }}</button>
    </div>
  </transition>
</template>

<script>
import updateStore from '@/stores/updateStore';

// Phase-A1 (2026-08-04, Task 2) — non-blocking: does not cover any app
// content, has no backdrop, and nothing else in the app is disabled while
// this shows. The user can keep working and reload whenever they choose;
// clicking Reload is the ONLY thing that applies the update (see
// updateStore.js / registerServiceWorker.js / service-worker.js for the
// full chain this triggers).
export default {
  name: 'UpdatePrompt',
  data() {
    return { updateStore };
  },
};
</script>

<style scoped>
.update-prompt {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  /* Edge-touching bottom element — same safe-area convention as
     App.vue's .notification-container/.beta-label. */
  bottom: calc(20px + var(--safe-bottom));
  z-index: 1600;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  border-radius: var(--radius-md);
  background: var(--purple);
  color: #fff;
  box-shadow: var(--shadow-md);
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  max-width: calc(100vw - 32px);
}

.up-text {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.up-reload-btn {
  flex-shrink: 0;
  border: none;
  border-radius: var(--radius-sm);
  background: var(--secondary);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 14px;
  cursor: pointer;
  transition: background 0.1s;
}

.up-reload-btn:hover:not(:disabled) {
  background: var(--secondaryLight);
}

.up-reload-btn:disabled {
  cursor: default;
  opacity: 0.7;
}

.up-slide-enter-active,
.up-slide-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.up-slide-enter-from,
.up-slide-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(12px);
}
</style>
